import "./ah1su-modal.styles.scss";
import {
  handleSignUpSubmit,
  signUpInitial,
  handleChange,
  passwordChange,
} from "../ah1/ah1.utils";
import { useNavigate } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import { UserContext } from "../../../contexts/users.context";
const AH1SUModal = ({ closeFunction }) => {
  const [signUpFields, setSignUpFields] = useState(signUpInitial);
  const navigate = useNavigate();
  const [loaderClass, setLoaderClass] = useState("aho1-loader-hidden");
  const { user } = useContext(UserContext);
  useEffect(() => {
    if (user) {
      navigate("/home");
    }
  }, [user]);
  const { restaurantName, restaurantEmail, adminName, adminPassword } =
    signUpFields;
  const [confirmPassword, setConfirmPassword] = useState("");
  return (
    <div className="ah1sumodal-container">
      <div className={loaderClass}>
        <div className="loader"></div>
      </div>
      <div className="aho2-signup-form-container">
        <span className="aho2-su-form-close" onClick={closeFunction}>
          X
        </span>
        <form
          className="aho2-su-form"
          onSubmit={(event) => {
            handleSignUpSubmit(
              event,
              signUpFields,
              adminPassword,
              confirmPassword,
              setLoaderClass
            );
          }}
        >
          <span className="ah-one-su-title">START YOUR JOURNEY HERE</span>
          <input
            type="text"
            name="restaurantName"
            className="ah-one-su-input"
            value={restaurantName}
            placeholder="Restaurant Name"
            onChange={(event) =>
              handleChange(event, signUpFields, setSignUpFields)
            }
          />

          <input
            type="text"
            name="adminName"
            className="ah-one-su-input"
            value={adminName}
            placeholder="Admin Name"
            onChange={(event) =>
              handleChange(event, signUpFields, setSignUpFields)
            }
          />
          <input
            type="text"
            name="restaurantEmail"
            className="ah-one-su-input"
            value={restaurantEmail}
            placeholder="Restaurant Email"
            onChange={(event) =>
              handleChange(event, signUpFields, setSignUpFields)
            }
          />
          <input
            type="password"
            name="adminPassword"
            className="ah-one-su-input"
            value={adminPassword}
            placeholder="Password"
            onChange={(event) =>
              handleChange(event, signUpFields, setSignUpFields)
            }
          />
          <input
            type="password"
            name="confirmPassword"
            className="ah-one-su-input"
            value={confirmPassword}
            placeholder="Confirm Password"
            onChange={(event) => passwordChange(event, setConfirmPassword)}
          />
          <button type="submit" className="ah-one-su-submit">
            Start Your Journey
          </button>
        </form>
      </div>
    </div>
  );
};
export default AH1SUModal;
